import * as protobuf from 'protobufjs';
import protoSource from '../_proto/clp.proto?raw';
import { IClpClientMessage, IClpServerMessage } from '../clpApi.interface';

const root = protobuf.parse(protoSource).root;

const ClpClientMessage = root.lookupType('clp.v1.ClpClientMessage');
const ClpServerMessage = root.lookupType('clp.v1.ClpServerMessage');

// int64 fields (lpId, coreSymbolId, timestamp) fit within Number.MAX_SAFE_INTEGER for our domain,
// so decode them as plain numbers; `defaults`/`arrays` keep repeated fields as [] rather than undefined.
const TO_OBJECT_OPTIONS: protobuf.IConversionOptions = { longs: Number, defaults: true, arrays: true };

export const encodeClientMessage = (message: IClpClientMessage): Uint8Array =>
  ClpClientMessage.encode(ClpClientMessage.fromObject(message)).finish();

export const decodeClientMessage = (data: Uint8Array): IClpClientMessage =>
  ClpClientMessage.toObject(ClpClientMessage.decode(data), TO_OBJECT_OPTIONS) as IClpClientMessage;

export const encodeServerMessage = (message: IClpServerMessage): Uint8Array =>
  ClpServerMessage.encode(ClpServerMessage.fromObject(message)).finish();

export const decodeServerMessage = (data: Uint8Array): IClpServerMessage =>
  ClpServerMessage.toObject(ClpServerMessage.decode(data), TO_OBJECT_OPTIONS) as IClpServerMessage;
